import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Menu, Grid } from 'antd';
import IntlMessage from '../util-components/IntlMessage';
import FAIcon from 'components/util-components/FAIcon';
import navigationConfig from 'configs/NavigationConfig';
import { connect } from 'react-redux';
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import utils from 'utils'
import { account } from 'api';
import { onMobileNavToggle } from 'redux/actions/Theme';
import { compose } from 'redux'
import { faChevronDown, faArrowUp } from '@fortawesome/pro-light-svg-icons'
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = '';
  if (key) {
    const arr = key.split('-');
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const { flags, sideNavTheme, routeInfo, hideGroupTitle, localization, onMobileNavToggle } = props;
  const [addOnSettings, setAddOnSettings] = useState({})

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          loadAddOns(),
        ]); 
      } catch (error) {
        console.error('Error loading data:', error); 
      }
    }; 
    loadData();
  }, []);
  const loadAddOns = async () => {
    let { data } = await account.addonsSettings()
    setAddOnSettings(data)
  }

  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false)
    }
  }
  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? 'light' : 'dark'}
      mode="inline"
      style={{ height: '100%', borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? 'hide-group-title' : ''}
    >
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <Menu.ItemGroup
            key={menu.key}
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  icon={
                    subMenuFirst.icon ? (
                      <FAIcon icon={subMenuFirst?.icon} className='anticon' />
                    ) : null
                  }
                  key={subMenuFirst.key}
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      {subMenuSecond.icon ? (
                        <FAIcon icon={subMenuSecond?.icon} className='anticon' />
                      ) : null}
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) :
                <>


                  {subMenuFirst.key === 'forms' && !addOnSettings.forms?.enabled ? 
                    null 
                    :
                    <>
                      {subMenuFirst.key === 'contacts' ? null :
                        <Menu.Item key={subMenuFirst.key}>
                          {subMenuFirst.icon ? <FAIcon icon={subMenuFirst?.icon} className='anticon' /> : null}
                          <span>{setLocale(localization, subMenuFirst.title)} </span>
                          <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                        </Menu.Item>
                      } 
                    </>
                  }  
                </>

            )}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <FAIcon icon={menu?.icon} className='anticon' /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu >
  );
};

const TopNavContent = (props) => {
  const { flags, topNavColor, localization } = props;
  const [addOnSettings, setAddOnSettings] = useState({})

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          loadAddOns(),
        ]); 
      } catch (error) {
        console.error('Error loading data:', error); 
      }
    }; 
    loadData();
  }, []);
  const loadAddOns = async () => {
    let { data } = await account.addonsSettings()
    setAddOnSettings(data)
  }
  
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (


          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <FAIcon icon={menu?.icon} className='anticon' /> : null}
                <span>{setLocale(localization, menu.title)} <FAIcon icon={faChevronDown} className='app-menu-chevron-icon' /></span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <FAIcon icon={subMenuFirst?.icon} className='anticon' />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) :
                <>

                  {subMenuFirst.key === 'forms' && !addOnSettings.forms?.enabled ?

                    null

                    :
                    <>
                      {subMenuFirst.key === 'contacts' ? null :
                        <Menu.Item key={subMenuFirst.key}>
                          {subMenuFirst.icon ? (
                            <FAIcon icon={subMenuFirst?.icon} className='anticon' />
                          ) : null}
                          <span>{setLocale(localization, subMenuFirst.title)}</span>
                          <span className='mr-6'>{subMenuFirst?.plan === 'pro' && <Avatar color={'#000000'} size={15} icon={<FAIcon icon={faArrowUp} className='anticon' />} />}</span>
                          <Link to={subMenuFirst.path} />
                        </Menu.Item>
                      }

                    </>
                  }


                </>

            )}
          </SubMenu>
        ) : (
          < Menu.Item key={menu.key} >
            {menu.icon ? <FAIcon icon={menu?.icon} className='anticon' /> : null}
            < span > {setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item >
        )
      )}
    </Menu >
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};


export default compose(withLDConsumer(), connect(mapStateToProps, { onMobileNavToggle }))(MenuContent);
//export default compose(connect(mapStateToProps, { onMobileNavToggle }))(MenuContent);
